import { api } from '@src/constants/api';
import { createMiddleware, Next, regularErrorHandling, regularThenResponse } from '@src/utils';
import { enumsActions } from '@src/store/reducers/enumsReducer';
import { projectActions } from '@src/store/reducers/projectReducer';
import { projectsActions } from '@src/store/reducers/projectsReducer';
import { SessionService } from '@src/services';

export const createProjectMiddleware = (http: any, sessionService: SessionService) => {
    const restServiceUrl: string = api.restServiceUrl;
    return createMiddleware({
        [projectActions.GET_NEW_PROJECT]: async ({ payload }: any, next: Next, state: any) => {
            delete state.project; // we need clear old data
            const response = await http.get(`${restServiceUrl}projects/new/type/${payload.projectType}`);
            response.data.environmentTypes = [];
            //change the string to number because saving encoding code page is type=number
            response.data.options['DegreeParallel'] = parseInt(response.data.options["DegreeParallel"]);
            response.data.options['ObjectDegreeParallel'] = parseInt(response.data.options["ObjectDegreeParallel"])
            response.data.options.DeployOptions['SaveEncoding'] = parseInt(response.data.options.DeployOptions["SaveEncoding"]);
            // Object.keys(response.data.options).forEach((key: any) => {
            //     if (response.data.options[key] === 'True' || response.data.options[key] === 'true') {
            //         response.data.options[key] = true;
            //     }
            //     if (response.data.options[key] === 'False' || response.data.options[key] === 'false') {
            //         response.data.options[key] = false;
            //     }
            // });
            next({ type: projectActions.SET_NEW_PROJECT, payload: { data: response.data } });
            return response;
        },
        [projectActions.GET_PROJECT_TEMPLATES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}projects/TemplateTypes/${action.payload.dbTypeId}`);
                next({ type: projectActions.SET_PROJECT_TEMPLATES, payload: { templates: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.IS_RM_MANAGE_BY_DBTYPE]: async (action: any) => {
            try {
                const response = await http.get(`${restServiceUrl}IsDBTypeManaged/${action.payload.dbTypeId}`);
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },

        //returns true if project exist (checks if draft has been deleted)
        [projectActions.GET_IS_PROJECT_EXISTS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/IsProjectHaveDraft`);
                next({type: projectActions.SET_IS_PROJECT_EXISTS,payload: {isProjectExists: response.data} });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_PROJECT_ENV_TYPES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/EnvTypesByTemplateType/${action.payload.templateId}`);
                next({ type: projectActions.SET_PROJECT_ENV_TYPES, payload: { environmentTypes: response.data } });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_PROJECT_ENUMS]: async (_: any, next: Next, state: any) => {
            next({ type: enumsActions.CONFLICT_RESOLVE_ACTION_TYPES });
            next({ type: enumsActions.CONTINUOUS_INTEGRATION_TYPES });
            next({ type: enumsActions.DUPLICATION_ACTION_TYPES });
            next({ type: enumsActions.FILE_VERSION_CONTROL_TYPES });
            next({ type: enumsActions.DEPLOY_MODE_TYPES });
            next({ type: enumsActions.SOURCE_CONTROL_PATH_TYPES });
            const enums = state.getState().enums;
            if (!enums || !enums.DBTypes) {
                next({ type: enumsActions.DB_TYPES });
            }
        },
        [projectActions.GET_ADDITIONAL_OPTIONS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}DBProperties/${action.payload.dbId}`);
                next({ type: projectActions.SET_ADDITIONAL_OPTIONS, payload: { additionalOptions: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.UPDATE_PROJECT]: async (action: any, next: Next) => {
            try {
                const response = await http.post(`${restServiceUrl}Projects/Draft/Update`, action.payload.project);
                //change the string to number because saving encoding code page is type=number
                response.data.options['DegreeParallel'] = parseInt(response.data.options["DegreeParallel"]);
                response.data.options['ObjectDegreeParallel'] = parseInt(response.data.options["ObjectDegreeParallel"]);
                response.data.options.DeployOptions['SaveEncoding'] = parseInt(response.data.options.DeployOptions["SaveEncoding"]);
                if (response.data.options['SourceControlMergeTempDBMode'] !== undefined) {
                    response.data.options['SourceControlMergeTempDBMode'] = parseInt(response.data.options["SourceControlMergeTempDBMode"]);
                }
                //response.headers.SilentRequest = true;
                next({ type: projectActions.SET_PROJECT, payload: { data: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_IMPACT_ANALYSIS_INIT]: async (action: any, next: Next) => {
            try {
                const payload = action.payload;
                let url = `${restServiceUrl}Projects/${payload.projectId}/Jobs/${payload.jobId}/Report/${payload.reportId}`;
                if (payload.jobEnv) {
                    url += `/Env/${payload.jobEnv}`;
                }
                const response = await http.get(url);
                next({ type: projectActions.GET_IMPACT_ANALYSIS_INIT, payload: { impact_analysis: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_RS_SCHEMES]: async (action: any, next: Next) => {
            try {
                const getData = {
                    //action.payload.type to action.type
                    type: action.type,
                    projectId: action.payload.projectId
                };
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/Schemas`, getData);
                next({ type: projectActions.GET_RS_SCHEMES, payload: { data: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },

        [projectActions.GET_IMPACT_ANALYSIS_VIEW_CHANGES]: async (action: any, next: Next) => {
            // change action.payload.type to action.type
            try {
                let url = `${restServiceUrl}Projects/${action.payload.projectId}/Jobs/${action.payload.jobId}`;
                if (action.payload.envId) {
                    url += `/Env/${action.payload.envId}`;
                }
                url += `/ValidationReport/Script`;
                const payload = {
                    reportId: action.payload.reportId,
                    schemaId: action.payload.schemaId,
                    objectType: action.payload.objectType,
                    objectName: action.payload.objectName
                }
                const response = await http.post(url,payload);
                next({ type: projectActions.GET_IMPACT_ANALYSIS_INIT, payload: { impact_analysis_script: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.UPDATE_IMPACT_ANALYSIS_FILTERS]: async (action: any, next: Next) => {
            try {
                const putData = {
                    //action.payload.type to action.type
                    type: action.type,
                    projectId: action.payload.projectId
                };
                const response = await http.put('http://localhost:3000/offlineScripts/mocks/getProject.json'
                    /*`${restServiceUrl}Projects/UnassignedManagedSchemas`, action.payload.project*/, putData);
                next({ type: projectActions.UPDATE_IMPACT_ANALYSIS_FILTERS, payload: { impact_analysis: response.data } });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.UPDATE_IMPACT_ANALYSIS_MAIN_ACTIONS]: async (action: any, next: Next) => {
            try {
                const putData = {
                    //action.payload.type to action.type
                    type: action.type,
                    projectId: action.payload.projectId
                };
                const response = await http.put('http://localhost:3000/offlineScripts/mocks/getProject.json', putData);
                next({ type: projectActions.UPDATE_IMPACT_ANALYSIS_MAIN_ACTIONS, payload: { impact_analysis: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_AVAILABLE_SCHEMAS]: async (action: any, next: Next) => {
            const response = await http.post(`${restServiceUrl}Projects/UnassignedManagedSchemas`, action.payload.project);
            next({
                type: projectActions.SET_PROJECT_DATA,
                payload: { availableSchemas: response.data, dbId: action.payload.dbID }
            });
            return response;
        },
        [projectActions.GET_HOSTS]: async (action: any, next: Next) => {
            try {
                const localJsonServerUrl = ''; // BUG
                const response = await http.get(`${localJsonServerUrl}/hosts`);
                next({ type: projectActions.SET_PROJECT_DATA, payload: { hosts: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_COMPARISON_TYPES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/Environments/ComparisonTypes`);
                next({ type: projectActions.SET_PROJECT_DATA, payload: { comparisonTypes: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_BASELINE_TYPES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/Environments/BaselineTypes`);
                next({ type: projectActions.SET_PROJECT_DATA, payload: { baselineTypes: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.ADD_UNAMANGED_SCHEMAS]: async (action: any, next: Next) => {
            try {
                const postData = {
                    projectDraft: action.payload.project,
                    connectionProps: action.payload.connectionProperties,
                    recEnvId: action.payload.environmentId,
                    recTempEnvId: action.payload.environmentTempId
                };
                const response = await http.post(`${restServiceUrl}Projects/UnmanagedSchemasForInstanceWithRecommendations`, postData);
                next({
                    type: projectActions.SET_PROJECT,
                    payload: { projectDraft: response.data.ProjectDraft, schemas: response.data.Schemas }
                });
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.SAVE_DRAFT]: async (action: any) => {
            const response = await http.post(`${restServiceUrl}Projects/Draft/Save`, action.payload.project);
            const data = response.data;
            if (data.projectDraft) {
                sessionService.set(`project_${data.projectDraft.id}`, data.projectDraft.name + ' (Draft)');
            }
            return response;
        },
        [projectActions.COMMIT_PROJECT]: async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Projects/Draft/Commit`, action.payload.project);
                return regularThenResponse(response, action, (response: any) => {
                    if (response.data.projectDraft) {
                        sessionService.set(`project_${response.data.projectDraft.id}`, response.data.projectDraft.name);
                    }
                });
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_PUBLISH_STATUS]: async (action: any) => {
            try {
                const response = await http.get(`${restServiceUrl} Project/${action.payload.projectId}/GetPublishStatus`);
                return response.data;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_EDIT_PROJECT]: async (action: any, next: Next) => {
            const response = await http.get(`${restServiceUrl}Projects/Edit/${action.payload.projectId}`);
            return regularThenResponse(response, action, (response: any) => {
                //change the string to number because saving encoding code page is type=number
                response.data.options['DegreeParallel'] = parseInt(response.data.options["DegreeParallel"]);
                response.data.options['ObjectDegreeParallel'] = parseInt(response.data.options["ObjectDegreeParallel"]);
                response.data.options.DeployOptions['SaveEncoding'] = parseInt(response.data.options.DeployOptions["SaveEncoding"]);
                if (response.data.options['SourceControlMergeTempDBMode'] !== undefined) {
                    response.data.options['SourceControlMergeTempDBMode'] = parseInt(response.data.options["SourceControlMergeTempDBMode"]);
                }
                // Object.keys(response.data.options).forEach((key: any) => {
                //     if (response.data.options[key] === 'True' || response.data.options[key] === 'true') {
                //         response.data.options[key] = true;
                //     }
                //     if (response.data.options[key] === 'False' || response.data.options[key] === 'false') {
                //         response.data.options[key] = false;
                //     }
                // });
                next({ type: projectActions.SET_EDIT_PROJECT, payload: { data: response.data } });
                next({ type: projectsActions.GET_PROJECTS });
                window['dbTypeId'] = response.data.dbTypeId;
            });
        },
        [projectActions.GET_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS]: async (action: any, next: Next) => {
            try {
                const url = `${restServiceUrl}Projects/${action.payload.projId}/EnvTypesWithEnvsAndDepStatusModified`;
                const response = await http({
                    method: 'GET',
                    url,
                    SilentRequest: action.silentRequest,
                    transformResponse: (data: any, header: any) => {
                        return window['cTransformResponse'](data, header, action);
                    }
                });
                next({
                    type: projectActions.RECEIVED_PROJECT_ENV_TYPES_WITH_ENVS_AND_DEPLOY_STATUS,
                    payload: { projectEnvTypesWithEnvsAndDeployStatus: response.data }
                });
                return response;
            } catch(error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_DB_TYPE_FLAGS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}DBTypeFlags/${action.payload.dbTypeId}`);
                next({ type: projectActions.SET_DB_TYPE_FLAGS, payload: { [action.payload.dbTypeId]: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_DB_TYPE_IMAGE]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}DBTypeImage/${action.payload.dbTypeId}`);
                next({ type: projectActions.SET_DB_TYPE_IMAGE, payload: { [action.payload.dbTypeId]: response.data } });
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_EXCLUDE_OBJECTS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/ExcludeObjects`);
                next({ type: projectActions.GET_EXCLUDE_OBJECTS, payload: { excludeObjects: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },        
        [projectActions.GET_RM_SCHEMAS]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/RMSchemas`);
                next({ type: projectActions.GET_RM_SCHEMAS, payload: { rmSchemas: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_RM_SCHEMAS_EXTENDED]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/GetRMSourceSchemasExtended/${action.payload.projectId}`);                
                next({ type: projectActions.GET_RM_SCHEMAS, payload: { rmSchemas: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.UPDATE_EXCLUDE_OBJECTS]: async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Projects/${action.payload.projectId}/ExcludeObjects`,
                                                 action.payload.excludeObjects);
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_STATIC_CONTENT]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/StaticData`);
                next({ type: projectActions.GET_STATIC_CONTENT, payload: { staticContent: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },        
        [projectActions.UPDATE_STATIC_CONTENT]: async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Projects/${action.payload.projectId}/StaticData`,
                                                 action.payload.staticContent);
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_DATABASE_TABLES_AND_U_INDEXES]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}StaticData/DatabaseSupportedTables/${action.payload.projectId}/${action.payload.dbcid}`);
                next({ type: projectActions.GET_DATABASE_TABLES_AND_U_INDEXES, payload: { staticContent: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_SYSTEM_PRE_DEFINED]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/Variables/SystemPreDefined`);
                next({ type: projectActions.GET_SYSTEM_PRE_DEFINED, payload: { systemPreDefined: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_USER_DEFINED]: async (action: any, next: Next) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/${action.payload.projectId}/Variables/UserDefined`);
                next({ type: projectActions.GET_USER_DEFINED, payload: { userDefined: response.data } });
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.GET_FILE_EXTENSIONS]: async (action: any) => {
            try {
                const response = await http.get(`${restServiceUrl}Projects/GetFileExtensions/${action.payload.projectId}`);
                return response.data;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.SET_PROJECT_VARIABLES]: async (action: any) => {
            try {
                const response = await http.post(`${restServiceUrl}Projects/${action.payload.projectId}/Variables`,
                                                 action.payload.variables);
                return response;
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        },
        [projectActions.TEST_SOURCE_CONTROL_FOLDER]: async (action: any) => {
            try {
                return await http.post(`${restServiceUrl}Misc/CheckSourceControlFolder`, action.payload);
            } catch (error) {
                return regularErrorHandling(action, error);
            }
        }
    });
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/middlewares/project.middleware.ts